import { initialize } from "../../javascript/suggest";
document.addEventListener("DOMContentLoaded",  () => initialize("lab"))
